<div class="flex align-items-center justify-content-center mt-3">
    <span class="p-input-icon-left">
        <i class="pi pi-search"></i>
        <input pInputText type="text" (input)="dt1.filterGlobal($any($event.target).value, 'contains')"
            placeholder="Search" class=" p-inputtext-sm" />
    </span>
</div>


<p-table #dt1 [value]="result.unitsofMeasures" [scrollable]="false" scrollHeight="350px" styleClass="p-datatable-sm"
    responsiveLayout="scroll" class="w-full m-5" styleClass="p-datatable-sm " [paginator]="true" [rows]="10"
    [rowsPerPageOptions]="[5, 10,20]" [rowHover]="true"
    [globalFilterFields]="['unitsofMeasureCode', 'unitsofMeasure', 'unitsofMeasureDescription']"(onRowSelect)="onRowSelect($event)">
    <ng-template pTemplate="header">
        <tr>
            <th></th>
            <th>UOM Code</th>
            <th>Units of Measure</th>
            <th>UOM Description</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-UnitsOfMeasure>
        <tr>
            <td>
                <p-tableRadioButton [value]="UnitsOfMeasure"></p-tableRadioButton>
            </td>
            <td>{{UnitsOfMeasure.unitsofMeasureCode}}</td>
            <td>{{UnitsOfMeasure.unitsofMeasure}}</td>
            <td>{{UnitsOfMeasure.unitsofMeasureDescription}}</td>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="4">No Records found.</td>
        </tr>
    </ng-template>
</p-table>